import React, {useState, useEffect} from 'react';
import {Header, Titulo} from '../elementos/Header'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import withRouter from './withRouter';
import Api from '../servicios/api'
import BtnRegresar from '../elementos/BtnRegresar'
import FormularioUbicacion from './FormularioUbicacion'
import favicon from '../imagenes/logoutm.png'
import Cargando from '../elementos/Cargando'

const EditarUbicacion = (props) => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [ubicacion, setUbicacion] = useState([]);

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        fetch(Api+"?consultarUbicacionID="+props.params.id)
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true);
            setUbicacion(datosRespuesta[0]);
        })
        .catch(console.log)
    }, [props]);

    if(!datosCargados){
        return(
            <Cargando />
        );
    }
    else{
        return (
            <>
                <HelmetProvider>
                    <div>
                        <Helmet>
                            <link rel="shortcut icon" href={favicon} type="image/x-con"/>
                            <title>Actualizar Ubicación</title>
                        </Helmet>
                    </div>
                </HelmetProvider>

                <Header>
                        <Titulo>Actualizar Ubicación</Titulo>
                        <BtnRegresar ruta="/ubicacion"/>
                </Header>

                <FormularioUbicacion  ubicacion={ubicacion}/>
            </>
        );
    }
}
 
export default withRouter(EditarUbicacion);